"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTabbable = void 0;
var tabbable = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', '[contenteditable]', '[tabindex]:not([tabindex="-1"])', 'audio[controls]', 'video[controls]'];

var findTabbable = function findTabbable(element) {
  if (element) {
    var tabbableElements = element.querySelectorAll(tabbable.join(','));
    return tabbableElements;
  }
};

var setTabbable = function setTabbable(element) {
  if (element) {
    var tabbableElements = findTabbable(element);
    return {
      first: tabbableElements[0],
      last: tabbableElements[tabbableElements.length - 1]
    };
  }
};

exports.setTabbable = setTabbable;